module.exports = __webpack_public_path__ + "static/media/donasi1.cd62c474.jpg";